var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-editions tw-py-6"},_vm._l((_vm.cmsEditions),function(edition,key){return _c('cms-edition',{key:key,attrs:{"edition":edition,"previousEdition":_vm.cmsEditions[key - 1]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }